import React, { PropTypes } from "react";
import ComponentRegistry from "Fratello/Common/ComponentRegistry";

export default function ListView({ view, markers, onChange }) {
    const CollectionPointView = ComponentRegistry.get(view);

    return (
      <div className="list-group">
        {markers.map((marker, index) => (
          <div key={index} className={`list-group-item py-20 border-bottom${marker.active ? " active" : ""}`}>
            <CollectionPointView
              {...marker} onChange={(event) => {
                  event.preventDefault();
                  onChange(marker);
              }}
            />
          </div>
            ))}
      </div>
    );
}

ListView.propTypes = {
    view: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    markers: PropTypes.arrayOf(PropTypes.shape({
        active: PropTypes.bool.isRequired,
    })),
};
ListView.defaultProps = {
    view: "CheckoutViewsCollectionPointView",
};



// WEBPACK FOOTER //
// ./app/Resources/public/rosco/js/Checkout/Views/ListView.jsx